import { Component, signal, ViewChild, inject, Input, SimpleChanges } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SwiperDirective } from '../../../shared/directive/swiper.directive';
import { SponserService } from '../Services/sponser.service';
import { SponserModel } from '../Model/sponser.model';
import { SharedModule } from '../../../shared/Module/shared.module';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { RouterModule } from '@angular/router';
import { SharedSponserService } from '../Services/shareSponser.service';

@Component({
  selector: 'app-sponsor',
  imports: [TranslateModule, SwiperDirective, SharedModule, CommonModule, RouterModule],
  templateUrl: './sponsor.component.html',
  styleUrl: './sponsor.component.css'
})
export class SponsorComponent {

  private sponserService = inject(SponserService)
  private SharedSponserService = inject(SharedSponserService)

  sponsers = signal<SponserModel[]>([]);
  private subs = new Subscription();   // container for all subscriptions
  @Input() bronze: boolean = false;

  ngOnInit(): void {
    this.updateSwiperOptions();
    this.loadData()
  }


  ngOnChanges(changes: SimpleChanges) {
    if (changes['bronze']) {
      this.updateSwiperOptions();
    }
  }

  // public swiperOptions = signal<any>({
  //   slidesPerView: this.bronze ? 6 : 5,
  //   spaceBetween: 30,
  //   slidesPerGroup: 1,
  //   loop: true,
  //   loopFillGroupWithBlank: true,
  //   centeredSlides: false,
  //   pagination: {
  //     el: ".swiper-pagination",
  //     // type: "fraction",
  //     type: "bullets",
  //     clickable: true,

  //   },
  //   navigation: {
  //     nextEl: ".swiper-button-next",
  //     prevEl: ".swiper-button-prev",
  //   },
  //   watchOverflow: false,
  //   autoplay: {
  //     delay: 3000,
  //     pauseOnMouseEnter: true,
  //   },
  //   breakpoints: {
  //     1500: {
  //       slidesPerView: this.bronze ? 6 : 5,
  //     },
  //     1300: {
  //       slidesPerView: this.bronze ? 5 : 4,
  //     },
  //     991: {
  //       slidesPerView: this.bronze ? 4 : 3,
  //     },
  //     767: {
  //       slidesPerView: this.bronze ? 3 : 3,
  //     },
  //     575: {
  //       slidesPerView: this.bronze ? 2 : 2,
  //     },
  //   }
  // })

  swiperOptions = signal<any>({});

  updateSwiperOptions() {
    this.swiperOptions.set({
      slidesPerView: this.bronze ? 6 : 5,
      spaceBetween: 30,
      slidesPerGroup: 1,
      loop: true,
      loopFillGroupWithBlank: true,
      centeredSlides: false,
      pagination: {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      autoplay: {
        delay: 3000,
        pauseOnMouseEnter: true,
      },
      breakpoints: {
        1500: { slidesPerView: this.bronze ? 8 : 5 },
        1300: { slidesPerView: this.bronze ? 7 : 4 },
        991: { slidesPerView: this.bronze ? 6 : 3 },
        767: { slidesPerView: 3 },
        575: { slidesPerView: 2 },
        0: { slidesPerView: 1 },
      }
    });
  }



  loadData(): void {
    const sub = this.sponserService.getAll().subscribe({
      next: (data) => {
        // بعد ما تجيبي البيانات من الـ signal أو الـ service
        const sortedData = data.value.sort(
          (a, b) => (a.displayOrder ?? 0) - (b.displayOrder ?? 0)
        );

        this.SharedSponserService.setSponsors(sortedData);

        if (this.bronze) {
          this.sponsers.set(
            this.SharedSponserService.bronzeSponsors()
          );
        } else {
          this.sponsers.set(
            this.SharedSponserService.otherSponsors()
          );
        }
        // console.log(" this.sponsers", this.sponsers())
      },
      error: (err) => {
        console.error('Error loading sliders:', err);
      }
    });
    this.subs.add(sub);
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();   // unsubscribe from all
  }
}
